import { CYBER_SNAKES_AUDIO_KEYS, CYBER_SNAKES_TEXTURE_KEYS } from '.'

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/animations/cyber-snakes/`

  if (!scene.textures.getTextureKeys().includes(CYBER_SNAKES_TEXTURE_KEYS.ATLAS)) {
    scene.load.atlas(
      CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      `${prefix}animation-cyber-snakes-images.png`,
      `${prefix}animation-cyber-snakes-images.json`,
    )
  }

  for( const value of Object.values(CYBER_SNAKES_AUDIO_KEYS) ) {
    
    if(!scene.cache.audio.exists(value)) {
      scene.load.audio(value, `sounds/${value}`)
    }
  }
}
